module.exports = __webpack_public_path__ + "img/bahrain.2366200b.svg";